import React from 'react';
import MagicForm from '../../../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../../Enums/MagicField.enum';

export interface LaboratoryActivationCollectingMethodValues {
	distribution: string;
}

interface Props {
	onSuccess: (values: LaboratoryActivationCollectingMethodValues) => void;
}

const formScheme: ItemScheme[] = [
	{
		type: MagicField.RADIOLIST,
		key: 'distribution',
		children: [
			{
				value: 'aloneInSurgery',
				title: 'component.laboratoryActivationCollectingMethod.aloneInSurgery',
			},
			{
				value: 'inLaboratoryCollectionRoom',
				title:
					'component.laboratoryActivationCollectingMethod.inLaboratoryCollectionRoom',
			},
			{
				value: 'combined',
				title: 'component.laboratoryActivationCollectingMethod.combined',
			},
		],
		settings: {
			required: true,
		},
	},
	{
		type: MagicField.CONDITION,
		settings: {
			rules: [
				{
					formControlKey: 'distribution',
					rule: 'equal',
					value: 'aloneInSurgery',
				},
			],
		},
		children: [
			{
				type: MagicField.TEXT,
				title: 'component.laboratoryActivationCollectingMethod.text',
			},
		],
	},
	{
		type: MagicField.CONDITION,
		settings: {
			rules: [
				{
					formControlKey: 'distribution',
					rule: 'equal',
					value: 'combined',
				},
			],
		},
		children: [
			{
				type: MagicField.TEXT,
				title: 'component.laboratoryActivationCollectingMethod.text',
			},
		],
	},
];

const LaboratoryActivationCollectingMethod: React.FC<Props> = ({
	onSuccess,
}) => {
	const handleSubmit = (values: LaboratoryActivationCollectingMethodValues) => {
		onSuccess(values);
	};

	return (
		<MagicForm
			formScheme={formScheme}
			onSubmit={handleSubmit}
			submitText='base.shared.continue'
		/>
	);
};

export default LaboratoryActivationCollectingMethod;
